import { useSelector } from 'react-redux'

import { RootState } from 'app/rootReducer'
import { MasterCampaigns } from 'features/campaigns/masterCampaigns/MasterCampaigns'

import { AgencyV2ClientPageLayout } from '../../../components/layouts/AgencyV2ClientPageLayout'

export const MasterCampaignsPage = () => {
  const currentAccount = useSelector((state: RootState) => state.app)

  return (
    <AgencyV2ClientPageLayout helmetTitle={'Master Campaigns'} headerTitle={`Master Campaigns: ${currentAccount?.currentAccount?.name}`}>
      <MasterCampaigns />
    </AgencyV2ClientPageLayout>
  )
}
